import React, { useMemo, Fragment, useEffect, useState, useRef } from 'react';
import { MaterialReactTable } from 'material-react-table';
import { useOutletContext } from 'react-router-dom';

const RightTable = ({ rightTableData, setSelectedItemsInRight, rightTableRowSelection, setRightTableRowSelection }) => {

    // console.log("rightTableDataToPop2:", rightTableData)

    const tableInstanceRef = useRef(null);
    const { refClientAccountCmsData } = useOutletContext();

    const fetchClientAccountCmsData = (key) => {
        if (refClientAccountCmsData?.Components && refClientAccountCmsData?.Components["ClientAccountDetails.SetupClientAccount"]) {
            const adminClientSubAccountCmsDataLabel = refClientAccountCmsData?.Components["ClientAccountDetails.SetupClientAccount"];
            return returnLabel(adminClientSubAccountCmsDataLabel?.Labels, key)
        }
        return '';
    }

    const fetchCommonComponentCMSLabel = (key) => {
        if (refClientAccountCmsData?.Components && refClientAccountCmsData?.Components["CommonComponent"]) {
            const commonComponentLabel = refClientAccountCmsData?.Components["CommonComponent"];
            return returnLabel(commonComponentLabel?.Labels, key)
        }
        return '';
    }
    const returnLabel = (labelArray = [], key) => {
        return labelArray.find((x) => x.Key === key)?.Phrase || '';
    }

    const columns = useMemo(
        () => [
            {
                accessorKey: "clientCode",
                header: fetchClientAccountCmsData('ClientAccountDetails.ClientCodes'),
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: { placeholder: fetchClientAccountCmsData("ClientAccountDetails.PlaceholderClientCodes") }
            },
            {
                accessorKey: "clientCodeName",
                header: fetchClientAccountCmsData('ClientAccountDetails.ClientCodesNames'),
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: { placeholder: fetchClientAccountCmsData("ClientAccountDetails.PlaceholderClientCodesNames") }
            },
        ],
        []
    );

    useEffect(() => {
        const selectedRowObjList = tableInstanceRef.current
            .getSelectedRowModel()
            .rows.map((eachSelectedRowModel) => {
                return eachSelectedRowModel.original
            });
        // console.log("tl-selected:", selectedRowObjList)
        setSelectedItemsInRight(selectedRowObjList)
    }, [rightTableRowSelection])

    return (
        <Fragment>
            {

                <MaterialReactTable
                    tableInstanceRef={tableInstanceRef}
                    columns={columns}
                    data={rightTableData}
                    layoutMode="grid"
                    enableGlobalFilter={false}
                    enableDensityToggle={false}
                    initialState={{
                        density: 'compact',
                        showColumnFilters: true
                    }}
                    muiTablePaginationProps={{
                        labelRowsPerPage: fetchCommonComponentCMSLabel('Common.Rowsperpage')
                    }}
                    enableRowSelection
                    getRowId={(originalRow) => `${originalRow.clientCode}---${originalRow.clientCodeName}`} //give each row a more useful id
                    onRowSelectionChange={setRightTableRowSelection} //connect internal row selection state to your own
                    state={{ rowSelection: rightTableRowSelection }}
                    enableStickyHeader
                    muiTableContainerProps={{
                        sx: {
                            height: { sx: 200, sm: 300, md: 500 },
                        }
                    }}
                />
            }
        </Fragment>

    );
};

export default RightTable;
